export const vaultI18n = {
  vault: {
    en: {
      ACTION: 'Action',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Are you sure want to delete?',
      CANCEL: 'Cancel',
      CHANGES_NOT_SAVED: 'Changes not saved',
      CLEAR: 'Clear',
      COMPANY_VAULT: 'Company documents',
      COPY_LINK: 'Copy Link',
      CREATE: 'Create',
      CREATE_FOLDER: 'Create Folder',
      CREATED_SUCCESSFULLY: 'Created successfully',
      CURRENT_FOLDER: 'Current folder',
      DELETE: 'Delete',
      DELETED_SUCCESSFULLY: 'Deleted successfully',
      DOWNLOAD: 'Download',
      DOWNLOAD_NOT_STARTED_MESSAGE:
        '<1>Click here</1> if the download does not start automatically.',
      FAILED_TO_DELETE: 'Failed to delete {{name}}',
      FAILED_TO_LOAD_DOCUMENT: 'We could not load the document.',
      FAILED_TO_SAVE: 'Failed to save',
      FIND_FILES_AND_FOLDERS: 'Start typing to find files and folders',
      FOLDER_IS_EMPTY: 'This folder is empty.',
      LINK_COPIED_TO_CLIPBOARD: 'Link copied to clipboard',
      NAME: 'Name',
      NO_SEARCH_RESULTS: 'No search results',
      PROCEED: 'Proceed',
      RENAME: 'Rename',
      RENAME_FAILED: 'Failed to rename',
      SAVE_CHANGES: 'Save changes',
      SAVED_SUCCESSFULLY: 'Saved successfully',
      SEARCHING_BLOCKS_ACTIONS:
        'You have an active search. This means that you cannot perform any actions until the search is cleared.',
      SELECTED: 'Selected {{count}}',
      SHARE_ENCRYPTED: 'Share encrypted',
      SHARE_ENCRYPTED_FAILED: 'Failed to share encrypted',
      SHARED_ENCRYPTED_SUCCESSFULLY: 'Shared encrypted successfully',
      START: 'Start',
      UPDATED_AT: 'Updated at',
      UPDATED_SUCCESSFULLY: 'Updated successfully',
      UPLOAD_FAILED: 'Failed to upload {{name}}',
      UPLOAD_FILE: 'Upload File',
      UPLOADED_SUCCESSFULLY: 'Uploaded successfully',
    },
    'sv-SE': {
      ACTION: 'Åtgärd',
      ARE_YOU_SURE_WANT_TO_DELETE: 'Är du säker på att du vill radera?',
      CANCEL: 'Avbryt',
      CHANGES_NOT_SAVED: 'Ändringar inte sparade',
      CLEAR: 'Rensa',
      COMPANY_VAULT: 'Företagsdokument',
      COPY_LINK: 'Kopiera länk',
      CREATE: 'Skapa',
      CREATE_FOLDER: 'Skapa mapp',
      CREATED_SUCCESSFULLY: 'Skapad framgångsrikt',
      CURRENT_FOLDER: 'Aktuell mapp',
      DELETE: 'Radera',
      DELETED_SUCCESSFULLY: 'Raderad framgångsrikt',
      DOWNLOAD: 'Ladda ner',
      DOWNLOAD_NOT_STARTED_MESSAGE:
        '<1>Klicka här</1> om nedladdningen inte startar automatiskt.',
      FAILED_TO_DELETE: 'Misslyckades att radera {{name}}',
      FAILED_TO_LOAD_DOCUMENT: 'Vi kunde inte ladda dokumentet.',
      FAILED_TO_SAVE: 'Misslyckades att spara',
      FIND_FILES_AND_FOLDERS:
        'Börja skriva för att söka efter filer och mappar',
      FOLDER_IS_EMPTY: 'Den här mappen är tom.',
      LINK_COPIED_TO_CLIPBOARD: 'Länk kopierad till urklipp',
      NAME: 'Namn',
      NO_SEARCH_RESULTS: 'Inga sökresultat',
      OK: 'Ok',
      PROCEED: 'Fortsätt',
      RENAME: 'Byt namn',
      RENAME_FAILED: 'Misslyckades att byta namn',
      SAVE_CHANGES: 'Spara ändringar',
      SAVED_SUCCESSFULLY: 'Sparad framgångsrikt',
      SEARCHING_BLOCKS_ACTIONS:
        'Du har en aktiv sökning igång. Detta innebär att du inte kan utföra vissa åtgärder förrän sökningen rensas.',
      SELECTED: 'Valda {{count}}',
      SHARE_ENCRYPTED: 'Dela krypterad',
      SHARE_ENCRYPTED_FAILED: 'Misslyckades att dela krypterad',
      SHARED_ENCRYPTED_SUCCESSFULLY: 'Delad krypterad framgångsrikt',
      START: 'Start',
      UPDATED_AT: 'Uppdaterad vid',
      UPDATED_SUCCESSFULLY: 'Uppdaterad framgångsrikt',
      UPLOAD_FAILED: 'Misslyckades att ladda upp {{name}}',
      UPLOAD_FILE: 'Ladda upp fil',
      UPLOADED_SUCCESSFULLY: 'Uppladdad framgångsrikt',
    },
  },
};
